import React, { createContext, useCallback, useContext, useRef, useState } from 'react';
import ToastStack, { ToastItem, ToastType } from '../components/common/ToastStack';

const DEFAULT_DURATION_MS = 5000;

interface ToastContextType {
  /**
   * 画面右上に約5秒で自動的に消えるトーストを表示する。
   * 複数回呼ぶとスタック（縦並び）で表示される。
   */
  showToast: (message: string, type?: ToastType, duration?: number) => void;
}

const ToastContext = createContext<ToastContextType>({
  showToast: () => {},
});

export const useToast = (): ToastContextType => useContext(ToastContext);

export const ToastProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [toasts, setToasts] = useState<ToastItem[]>([]);
  const idRef = useRef(0);

  const dismissToast = useCallback((id: number) => {
    setToasts((prev) => prev.filter((toast) => toast.id !== id));
  }, []);

  const showToast = useCallback((
    message: string,
    type: ToastType = 'success',
    duration: number = DEFAULT_DURATION_MS,
  ) => {
    idRef.current += 1;
    const id = idRef.current;
    setToasts((prev) => [...prev, { id, message, type, duration }]);
  }, []);

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <ToastStack toasts={toasts} onDismiss={dismissToast} />
    </ToastContext.Provider>
  );
};
